(function() {
  document.addEventListener('DOMContentLoaded', function() {
    function updateRobotsTag() {
      const url = window.location.href;
      const head = document.querySelector('head');
      let robotsTag = document.querySelector('meta[name="robots"]');
      let canonicalTag = document.querySelector('link[rel="canonical"]');

      const hasSort = url.includes('sort_by=');
      const hasFilter = url.includes('filter.v.');

      if (hasSort || hasFilter) {
        if (!robotsTag) {
          robotsTag = document.createElement('meta');
          robotsTag.name = 'robots';
          head.appendChild(robotsTag);
        }
        robotsTag.content = 'noindex, nofollow';

        if (canonicalTag) canonicalTag.remove();
      } else {

        if (robotsTag) robotsTag.remove();

        if (!canonicalTag) {
          canonicalTag = document.createElement('link');
          canonicalTag.rel = 'canonical';
          canonicalTag.href = window.location.href.split('?')[0];
          head.appendChild(canonicalTag);
        }
      }
    }

    updateRobotsTag();

    const originalPushState = history.pushState;
    history.pushState = function() {
      originalPushState.apply(this, arguments);
      updateRobotsTag();
    };

    window.addEventListener('popstate', updateRobotsTag);
  });
})();
